import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { getDefaultCalendar } from '../../../../reducers/accounts'
import DoneButton from '../../../DoneButton';
import * as ACTIONS from '../../../../actions'
import Preview from '../../create-event/Preview';
import { AnonymousProposalVotePage } from '../../proposal/anonymous';
import Dropzone from 'react-dropzone';
import CTA from '../../create-event/periods/cta'
import NOOP, { NO_BUBBLES } from '../../../../utils/noop';
import {
  Button,
  ButtonGroup
} from '@material-ui/core';
import {
  ArrowLeft,
  ArrowRight,
  ImageOutlined as ImageFile
} from "@material-ui/icons";
import "./company.scss";
import { getProfile } from '../../../../reducers/profile';
const DEMO_INVITEE_QUERY = { email: "guest@mail.com" };
const PLACEHOLDER = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAzCAYAAAAXUx+QAAALg3pUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHjatZhrdtw6DoT/cxWzBD5BcjkkQJ4zO5jlzwe54zxu4utM7rgTd0ctUSKqUFVIOP/59w3/4qfkIqG2PmSKRH7qrDMvPoz49vP2nmJ9fj8/bb2+S98fD6W8vsgc8s+vf8t5nb843r5e0Ovr+P7+eOj6Wme8Fnp98WXB4nfOfHidN14Llfx2PL3+HebrulW/2c7rb+nPEu8n//jv2imGNQ6WHPIpqUR+V79L8b+lLN4Tv/0b//T2efK7sthPaxfeP/5QvJl+Xru4XmeU70sRorxOkB9q9Dqe2s9r91To2ydKXz7m778YJ+747c83tbvXxr3nbXerCpWS8NpUfC3xfOJEFqnluUx4df42PvfnNXkNtqgU3UBz89KQZsrU9KaaLK1003neNSmPWPPJnfecNZfn2Cg9z6wPGNVf6eYODBbKACcFtcLh/P4s6bnvfO6naXBnS5yZE4slrvjLK/zs4P/yel/oXqduSl7M+VY1nis7AXkMR85/cxaApPuqaXvq+7zCO6xffxzYAoLtKfNggyvutyV2S1+5VR6cC+e1WEN8o3vq9lqAEnHvxsPA6JqipNKSpNhz7ilRxwE+iyfPpeYNAqm1bClcsClFAGdkvzfX9PScm1t+O4y0AEQrUjrQ0CiAVWuDP70OOLRaaTW01qT1NtpsS4pUaSLSxTVq9dJrb11676PPvkYZdbQho48x5lgzz4KEtSmzhznmnGtx08XSi6sXZ6y18y677rZl9z323Euhj1ZtKtp16NRl2YrR/ibWgw2btk46UOnU046cfsaZZ124dsutt125/Y4773pH7YXq96ilH5D7GLX0Qs0Rq895/StqHO79yxLJ5aQ5ZiCWawLx7ghA6OyYxZFqzY6cYxanC1jLoJaag2PJEQPBelJuN71j9xW5D3ELrf4WbvlXyAWH7p9ALjh0L+T+ittPULP1OEp5APIu9JrGchG228qN0gc6cuD5GbfwlKup9YbeZNO0h8ievueoVKLHImsNlVS73LbOWCMsDC3y60/ff3Oh07tKP1GtbO3Yk5bVznKFNOQQ/2dLqS2bs7WxIzBqMl1a0pBi2/IGig9vEf58U/+HhQRG0Ac7Hj+WjJ2WfhJdG5udXZbzCCBd+HeyUU8uA8wWkDrV79y5BpiSIc1YZ77dgQYde9UtEQbgQVTs5FWHXwbghmjGuwzuOOqnzSmpZQ1KcxejknXbmCfJRECPxZ6UXoN9u1QUkDWrJBCLVWTtbYjBLHfSYLdLjQdCAuMd5lls0dNtlDW4cYT7HmAafz7zHj57os59jUcrZ1IDNAGjUn9iCsaubrhoTB+73LOP9nsGitIb7dksbcQl33NUCIhtEzCjKSZ48I0+r66t7DhaL+0GSx3IDoXumu6aFFd3X13X3EKJd84ISInKoZ0xoTiK9uU3i7L3mrIviPaA9rUDNhsIpxWdGRRF0qCsqbj+lMEGFuFi83ycUTFihE8tV92lnSq0ANHPc5Et22X4lRh3QYpyMRrpxtPHcjXhpKNOrAGUFW9Ex/uWcveu7JkHC3dUmwuBKnVs3XfLaHWtzuk6Rt1dtcLSOo5zCXY2GwjUnl6FNe06fUVmYMPaVj1DKxIMv+0mlC8VqOThfM1r1OHkfDlGq5siQY3bcAF/YtJIX8dw6r2eFHlMeHujoQE8RlFDxwmAlRtr3bhSmigBmhz7kr6NaLxoB6q+UD0LchdaTtXqmFBm4BQxz4jxY1B6uWro6US5vRtwaitzt2oCeTrFhDhbWWCEAcvXiKpYUF7JbCjXn2YcLF1UTl1XS7+Y4+hpI991QH05hQKMRi/BvSPh3Nb3s70oLGwervrkchDCDND7nruhgbVbpiHXhVbwJWtahfZu9KnHwTAu2riVcuMqNOpySewoOl4k3UrE0NY9rLWwQOt6FapPvXDc4NjZ/uz5AL8wCJFM1i1cAzpRi+w4qdiOWBAeC7ONxtYr67D+XGDiLbeoHvuZFbYF8u9QRLxl0C/EEoeHzZF0xyGxfFYDwud6vyEvXq5Bxqb0WwAwdTTrnGG0n8YAj5l7SH3nVFyRktPDjfRAccby1oJigGmrYj+V+C4EGmW0obQyz6i3+11C3zTgrZ2qjEqq3NBAMj18GsyFgZd+eLiw7qI+D773jo2Xe+vurGSMaEFXGjvtrYhMQlnolX73kkGHolNYGx6IKm9s+zRV2yM7AAtO9TS5bHjkYMw6SMU60pkq0j6Tror7FHINqs9+8Pim+CYDjLo2q3a3mWp02cD2ZaBDBBcIucVIIDt1j2JI/OoMkgwqCn/PRkbSIh0B6LFzABdvZund8qC13X7QWIWQUgY7dZ5PdM9bVUchAuVk2WuGpfPInlnGObLMZrvaOvWZOeP1JBO7c4R4qwLsdhsZNEXDOeuwVHGoPFqL6xkfKcA0HAClIUEi9Mgw2CidZlSuKcymCxUvxRJQuLg1k5biZrbbxMU0aThxs6BYS81yoXvERAzabrSEvKQpx1B9LGek65KpE7PAJRoyXk5cm2bzKHK2P2KcNfkbXo1cHi3THaMse0hhbA0BWVx0cFmTROdktnePy6DTr++SlkP7cZIIvxE5gOii+cadL7gbvxOCTao8q4WHqQNd3gBCDJVbSBGEdeiImR5qWPmGfq8TsudlEAlR1gtAzedF5Ap9CmSUZiR5TBH3q4ce6Ood7+Rh8QKnOzK7vTBEeQoNXdTJzFgwyTEshNIHNHRAYFdyUlDBauYRmGzoPgM0xMTMmRFBLNHGzjJOLDw4Fc3iWb4l7hLIzDAWF4URkzHmSe6oHYSy5uxHKGkWZTskAfq9M5Lgb4Iv76kYhF9qEqihM5XyDJo1ZyFAdTYLhuifFSSwovQHzBOdodMfkefqhznhNCQck0f0A1kOprc9+5ArmX0x9GDIWgsiDFNxQKGYvbnQKuihUMlZzcowjK+NYt5ALJTrBSesIBSQjHczGoGpJjEBFGp8O8igVOCHrVXDvureTBA9KxMXFI8h2aU2TL8ujgKtmdhQJTSxrpQImofebWzSIo2eiEOXsXpQxa2lZDoAvXdhK226Ce6K8jSMLushwePL2yUU98YN46S1SAolZbSEADXnQZrMNQ3vmJfCBwYyqJK37X3zOovUX9yAhCs6hhi5JMfr/w3mkcJO5GRMH6q4qHPTyjAnJ7AjMjUeLWyA2+BfxYS01tcqMqykUnigrJvaYu64J2pHtWhHpqaJMB54vMJc3Hqdy6MfUfX/TTjI8cCBR4Jpl5g4mwD2diKki2ZVIXVfgg4BB6NADy52xJYx2IZzKjlyI8KRYD7KwUrIRLixuFJgO8yL/RtRSAUg6TdYBcUDkp87gQkf15qWpxbW9twG4evEYKIH+MmmZRMtr10vgYdz2Fg9iz3aEL58+IN3+mnXwL2H5ALMHsWYRBIxyl2Z7Vysv1Cl+0TlR3CWPXMbKC+y5ORJc2YsRmpHyT6fMMMnep8olyep+RU5oxlD/K5HN9Mz+WkinkQTnBF3Xkg2oLcM13NgIt6M7jgoTU4oWw1Xc1WGv+IpOYMAegx17LtkgZstYi20iT5qBv9vp8kwKh0bYTbCYgaErgRvVOzcCS3QuE5nLkuvbTFIEXDxHKYxbp5ji4EBXuhoSGN3Yy30JIORSGeoQ5yE1IQFHnSM4HHeQhq92Z5Ntc0B0Y71ECKoAnWgTXARbSDs+uYRmLV5DDKsG39s6cP38HcnfPb9TxZCTFC8mxgb7glZkbQKdxN6jjIIEwR5SPrF7Es8wAMzEGRjYKIb9i8WD//Etj5eSFxvsAUft+hYgEExCBCKRZhPk4OsAr86AyH8CcPHAM5rjMyuTUwpR4+3AzoBJfqF45n+sERVyO6/CL7h02P037z/aiHmVWTq0tH3Mnoun5uVaf4yPjPHvoUKHnOG/wLg02Dj6RMLSQAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cBCgoTL1LhsVMAAAR9SURBVHja7ZxPSBtbFIe/hEdDQVIHgig2VISJFSW+IBIoFNtuXUs3DS7czaIwuyotDAjShfA2EoSixaW6sbRZFiyFgAv/BUqogVQZDDIERgdNchU7b9WhU6vv8Vq1L72/3b333JB8OfeXc+5AAgDVarXNdd2Xruv+CTQi9bO0GAwG9evXr28FqtVq2+fPn9ck4AvTXjAYTARd1/1LQr5QNZ6cnLwMHB4eupLFJWS1ZHA5WS1BX5IkaAlagpaSoCVoCVoikKAlaCkJWoI+T47joGlaXYP+41d/g0IIPn78iKIoRKNR37xlWVSrVW7duoVlWd66EILt7W0AmpubCYfDMqPPk2ma6LqOaZpks1k0TUMIgeM46LpONptlZ2eHdDrN7du3vdOh6zqFQoG1tTUmJiZwHEdm9Hl68eIFhmHQ1NTkza2vr1OpVOjv7+fhw4cA9Pb28vTpUwDev3/P4OAg9+/f976shYUFhoeHZUafpY2NDW7cuOGN29raKJfLVCoVOjs7vfmvrWF3d5ebN29641Ao5NmIBH2G7t27Rzab9Xw3k8kQjUaJx+NMTU1hWRZCCN68eePtaW9vZ3V11Rt/+PCBrq6uK/8sv8QTFsdxaGlpYWhoyJsbGBjg7t27TE9PY9s25XKZoaEhkskkALlcjrdv3xIOh+nu7ubBgwccHh4CkMlkyGQyRCIRFEVB0zRCoZAE/V+Uy+WIx+M+6Lquy/LuZ5d8+XyeqakpAFRVvfIfu7rNaNkZSv3/QAshzl23LOuH9telR1uWhWEY7OzsMDY2RjweZ25ujnfv3nkxuq6jqqoX+0XfNi1CCLLZLMVikfb2du7cueOrKpaXl5mdnUVVVWzb5tGjR8RiMZaXlxkfH6e1tdWrbAYGBuoLdFNTE+l0mrm5OW+uVCoxMjJy6g7DMAyeP39OOBzGNE0MwyCdTvuaEMuyePz4MTMzMz7IQgjGx8eZn5/34r7sr1QqjI6OeiXib2Mdtm1Tq9V8FrC9vU1vb6/X7UWjUSKRiC9GCEEikWBmZobOzs5Tdxmtra3s7+8D8OnTJ1RV9U5VpVLBNM1Lt5UrLe+SySSrq6uUSiUKhQKGYVCr1WhoaPDFKYriAxMKhYjFYjQ2Nvos5ctaf38/hmGgqipLS0uMjY15LfzW1hbFYpGVlRVfA1TXoL/2x83NTV6/fk1fXx8HBwf/2o6+1ebmJgcHB57VDA8Pk0qlmJ+fJ5lMemAHBwdJpVK8evWqvq3DcRzfkbdtG4COjg5WVla8NcuyKBQKPh8/tzEIBM68Fs3lcqcspu6to1arMTk5Sblc9nV3oVCIkZERnjx5QiQSoVwu+yqQf5KqqsRiMTRNQ1VVCoUCo6OjAOTzeZ49e0ZPTw8bGxtMTk7+Xp2hEOK7lz6O4/zQ05Gz9v/o68oWXHaGUhK0BC1BS0nQErQELRFI0BK0lAQtQUvQsCcxXALoQCCwLjFcuBYDtm23Xbt2Tf5fxwXJdd294+PjRFBRlK2jo6MEsCix/FzArusuHR8fJxRF2fobhHcNlebcGJUAAAAASUVORK5CYII=`;

export default function Company({ showPage = 0 }) {
  const { t } = useTranslation();
  const profile = useSelector(getProfile);
  const [selectedFile, setSelectedFile] = React.useState();

  const defaultCalendar = useSelector(getDefaultCalendar);
  const demo = React.useMemo(() => {
    if (!defaultCalendar) return undefined;
    if (!profile || !profile.billing || !profile.billing.is_admin) return undefined;
    let company = profile.billing.company || {};// placeholder
    let logo = selectedFile || (company.logo_url && company.logo_url + '?' + Date.now()) || PLACEHOLDER; // or actual...
    return {
      id: "00000",
      "title": "test demo",
      "important": false,
      "location": "",
      "conference": "gmeet",
      "duration": 60,
      "customduration": 10,
      "currenttimeframe": 0,
      "reminders": [
        "15"
      ],
      "notes": "This is a description",
      "calendar": {
        "accountId": defaultCalendar.accountId,
        "calendarId": defaultCalendar.calendarId,
        "provider": defaultCalendar.provider,
        "email": defaultCalendar.email,
        "name": defaultCalendar.name,
        "timezone": defaultCalendar.timezone
      },
      "organizer": {
        "name": "Host",
        "email": "Host@mail.com",
        "UserID": "001",
        "first_name": "Host",
        "last_name": "Host",
      },
      "invitees": [
        "guest@mail.com",
        "guest2@mail.com"
      ],
      "inviteesDetails": {
        "guest@mail.com": {
          email: "guest@mail.com",
          "isForced": false,
          "isForbidden": false
        },
        "guest2@mail.com": {
          email: "guest2@mail.com",
          "isForced": false,
          "isForbidden": false
        }
      },
      "slots": [
        {
          "day": "2033-01-05T23:00:00.000Z",
          "slots": [
            {
              "start": "2033-01-06T08:00:00.000Z",
              "end": "2033-01-06T09:00:00.000Z"
            },
            {
              "start": "2033-01-06T09:00:00.000Z",
              "end": "2033-01-06T10:00:00.000Z"
            },
            {
              "start": "2033-01-06T10:00:00.000Z",
              "end": "2033-01-06T11:00:00.000Z"
            },
            {
              "start": "2033-01-06T12:00:00.000Z",
              "end": "2033-01-06T13:00:00.000Z"
            },
            {
              "start": "2033-01-06T14:00:00.000Z",
              "end": "2033-01-06T15:00:00.000Z"
            },
            {
              "start": "2033-01-06T15:00:00.000Z",
              "end": "2033-01-06T16:00:00.000Z"
            },
            {
              "start": "2033-01-06T16:00:00.000Z",
              "end": "2033-01-06T17:00:00.000Z"
            }
          ]
        },
        {
          "day": "2033-01-08T23:00:00.000Z",
          "slots": [
            {
              "start": "2033-01-09T08:00:00.000Z",
              "end": "2033-01-09T09:00:00.000Z"
            },
            {
              "start": "2033-01-09T09:00:00.000Z",
              "end": "2033-01-09T10:00:00.000Z"
            },
            {
              "start": "2033-01-09T10:00:00.000Z",
              "end": "2033-01-09T11:00:00.000Z"
            },
            {
              "start": "2033-01-09T11:00:00.000Z",
              "end": "2033-01-09T12:00:00.000Z"
            },
            {
              "start": "2033-01-09T12:00:00.000Z",
              "end": "2033-01-09T13:00:00.000Z"
            },
            {
              "start": "2033-01-09T14:00:00.000Z",
              "end": "2033-01-09T15:00:00.000Z"
            },
            {
              "start": "2033-01-09T15:00:00.000Z",
              "end": "2033-01-09T16:00:00.000Z"
            },
            {
              "start": "2033-01-09T16:00:00.000Z",
              "end": "2033-01-09T17:00:00.000Z"
            }
          ]
        }
      ],
      "remaining_slots": [
        {
          "day": "2033-01-05T23:00:00.000Z",
          "slots": [
            {
              "start": "2033-01-06T08:00:00.000Z",
              "end": "2033-01-06T09:00:00.000Z"
            },
            {
              "start": "2033-01-06T09:00:00.000Z",
              "end": "2033-01-06T10:00:00.000Z"
            },
          ]
        },
        {
          "day": "2033-01-08T23:00:00.000Z",
          "slots": [
            {
              "start": "2033-01-09T08:00:00.000Z",
              "end": "2033-01-09T09:00:00.000Z"
            },
            {
              "start": "2033-01-09T15:00:00.000Z",
              "end": "2033-01-09T16:00:00.000Z"
            },
          ]
        }
      ],
      "generateLink": false,
      "holdSlots": false,
      "ignore_initial_avail": false,
      "vote_required": false,
      "preview_logo": logo,
      "company": { logo_url: logo }
    };
  }, [selectedFile, profile]);

  if (!demo) return null;
  return <div data-testid="company-page" key="page" className="section company-premium-user">
    <div className="title">{t('settings.sections.company.premium.title')}</div>
    <div className="section-company-content">
      <Carroussel demo={demo} showPage={showPage} />
      <AdminEmailLogo selectedFile={selectedFile} setSelectedFile={setSelectedFile} profile={profile} />

    </div>
  </div>;
}

const ACCEPT = {
  'image/*': ['.png', '.jpg'],
}

function AdminEmailLogo({ selectedFile, setSelectedFile, profile }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [reseting, setreseting] = React.useState(false);
  const [profileLogo, setprofileLogo] = React.useState(profile && profile.billing && profile.billing.company && profile.billing.company.logo_url);
  React.useEffect(() => {
    // when profile change, update state!
    setprofileLogo(profile && profile.billing && profile.billing.company && profile.billing.company.logo_url);
  }, [profile])
  const editor = React.useRef(null);

  const changeHandler = (event) => {
    // convert to b64
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(event);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    }).then(dt => setSelectedFile(dt));

  };
  const handleSubmission = React.useCallback((e) => {
    if (editor.current === null) return;
    NO_BUBBLES(e)
    setLoading(true)
    const dataUrl = editor.current.toDataURL();
    return fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "File.png", { type: "image/png" })
        return dispatch({
          type: ACTIONS.WORKER_SET_COMPANY_LOGO,
          payload: file,
          resolvers: {
            resolveOn: ACTIONS.WORKER_SET_COMPANY_LOGO_SUCCESS,
            rejectOn: ACTIONS.WORKER_SET_COMPANY_LOGO_ERROR
          }
        }).then(() => {
          enqueueSnackbar(t('settings.sections.company.premium.perso.publishSuccess'), { variant: 'success', className: "snack-success" });
          setSelectedFile();// clear act
        }).catch((err) => {
          // enqueueSnackbar
          enqueueSnackbar(t('settings.sections.company.premium.perso.publishError'), { variant: 'error', className: "snack-error" })
        }).then(() => setLoading(false))
      })

  }, [selectedFile, editor])
  const handleEmptySubmission = React.useCallback(() => {
    if (!profileLogo) {
      setSelectedFile();
      return; // no need to call server
    }
    setreseting(true)
    dispatch({
      type: ACTIONS.WORKER_SET_COMPANY_LOGO,
      resolvers: {
        resolveOn: ACTIONS.WORKER_SET_COMPANY_LOGO_SUCCESS,
        rejectOn: ACTIONS.WORKER_SET_COMPANY_LOGO_ERROR
      }
    }).then(() => {
      setprofileLogo("")
      setSelectedFile();
      enqueueSnackbar(t('settings.sections.company.premium.perso.resetSuccess'), { variant: 'success', className: "snack-success" })
    }).catch((err) => {
      // enqueueSnackbar
      enqueueSnackbar(t('settings.sections.company.premium.perso.resetError'), { variant: 'error', className: "snack-error" })
    }).then(() => setreseting(false))
  }, [profileLogo]);
  const clearLogo = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedFile(profileLogo);
  }, [profileLogo]);
  return <div className="dropper">
    <Dropzone
      onDropAccepted={(dropped) => changeHandler(dropped[0])}
      noKeyboard
      accept={ACCEPT}
      maxFiles={1}
      style={{ width: '250px', height: '250px' }}
    >
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <div className="drop-zone">
            {selectedFile && <span className='annuler' onClick={clearLogo}>{t('common.cancel')}</span>}
            <div className="drop-content">
              {(selectedFile || profileLogo) ? <>
                {selectedFile ? <AvatarDisplay width={250} height={250} image={selectedFile || profileLogo} ref={editor} />
                  : <img src={profileLogo + '?' + Date.now()} className="logo-url" alt='logo' />}
                <input {...getInputProps()} />
              </> : <DropPlaceholder setSelectedFile={changeHandler} />}
            </div>
          </div>
        </div>
      )}
    </Dropzone>
    <div className="actions">
      {selectedFile && <CTA handleSubmit={handleSubmission}
        label={t('settings.sections.company.premium.perso.publishLogo')}
        canSubmit={!loading && !reseting}
        isGeneratingLink={loading}
        name="publish"
      />}
      {profileLogo && !selectedFile && <><input data-testid="file-selector" type="file" name="file-select" id="file-select" accept="image/*" className="hidden" onChange={(e) => changeHandler(e.target.files[0])} />
        <DoneButton label={<label for="file-select" className="as-button">{t('settings.sections.company.premium.perso.changeLogo')} </label>} /></>}
      {(profileLogo || selectedFile) && <CTA handleSubmit={handleEmptySubmission}
        className="grey"
        label={t('settings.sections.company.premium.perso.resetLogo')}
        canSubmit={!loading && !reseting}
        isGeneratingLink={reseting}
        name="reset"
      />}
    </div>
  </div>
}
function DropPlaceholder({ setSelectedFile }) {
  const doSelect = React.useCallback((e) => {
    setSelectedFile(e.target.files[0])
  }, [setSelectedFile])
  return <>
    <input
      data-testid="file-selector"
      accept="image/*"
      id="contained-button-file"
      type="file"
      onClick={NO_BUBBLES}
      onChange={doSelect}
    />
    <ImageFile className='drop-img' />
    <Trans i18nKey='settings.sections.company.premium.perso.uploadText'
      components={{
        label: <label htmlFor="contained-button-file" />,
        span: <span className="upload-btn" />,
      }}>
      Déposer votre logo ou <label><span>parcourir</span></label><br />Fichier .jpg ou .png
    </Trans></>
    ;
}
const AvatarDisplay = React.forwardRef(({ image, width, height }, ref) => {
  React.useEffect(() => {
    // get file data
    let img = new Image();
    img.src = image;
    // cannot test img onlad and canvas stuff...
    img.onload = /* istanbul ignore next */() => {
      let canvas = document.getElementById("cnv");
      if (!canvas) return;
      const MAX_WIDTH = width;
      const MAX_HEIGHT = height;
      let w = img.width;
      let h = img.height;
      // check higher value? expect square image?
      if (w >= h) {
        h *= MAX_WIDTH / w;
        w = MAX_WIDTH;
      } else {
        w *= MAX_HEIGHT / h;
        h = MAX_HEIGHT;
      }
      canvas.width = w;
      canvas.height = h;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, w, h);
    }
  }, [image, ref]);
  return <canvas data-testid="cnv-avatar" id="cnv" ref={ref} width={width + "px"} height={height + "px"}>

  </canvas>
});
const CARROUSSEL = [
  { title: "settings.sections.company.premium.perso.emailTitle", hnd: (demo) => <Preview proposal={demo} /> },
  {
    title: "settings.sections.company.premium.perso.voteTitle", hnd: (demo) => <AnonymousProposalVotePage lightTheme={1} setLightTheme={NOOP}
      showActionPanel={NOOP}
      loading={false} exists={true} error={undefined}
      proposal={demo}
      isVoting={0}
      query={DEMO_INVITEE_QUERY}
      IMustReply={true}
      isLastToVote={false}
      setIsVoting={NOOP}
      IAmUnknown={false}
      isFake={true} />
  }
]
function Carroussel({ demo, showPage = 0 }) {
  const { t } = useTranslation();
  const [navigation, setNavigation] = React.useState(showPage);
  const doPrev = React.useCallback(() => {
    if (navigation > 0) setNavigation(navigation - 1)
  }, [navigation])
  const doNext = React.useCallback(() => {
    if (navigation < CARROUSSEL.length - 1) setNavigation(navigation + 1)
  }, [navigation])
  return <div className="carroussel">
    <div className="carroussel-header">
      <span className='carroussel-title'>{t(CARROUSSEL[navigation].title)}</span>
      <ButtonGroup size="large" >
        <Button disabled={navigation === 0 ? true : undefined} onClick={doPrev}><ArrowLeft /></Button>
        <Button disabled={navigation === CARROUSSEL.length - 1 ? true : undefined} onClick={doNext}><ArrowRight></ArrowRight></Button>
      </ButtonGroup>
    </div>
    <div className='carroussel-content  fancy-scroll'>
      {CARROUSSEL[navigation].hnd(demo)}
    </div>
  </div>

}